{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/MNA",
	"name": "MNA",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "MNA",
	"purpose": "Évaluation du risque et/ou de la dénutrition",
	"description": "L'évaluation se déroule en deux étapes. Nous enregistrons d'abord les résultats du questionnaire initial, pour lesquels des scores supérieurs à 11 (max. 14) indiquent un état nutritionnel acceptable. Les patients classés comme présentant un « risque de malnutrition » (score inférieur à 12) doivent remplir l'intégralité du questionnaire. Un score inférieur à 17 points renvoie à un état de malnutrition. Un score entre 17 et 23.5 indique qu’il existe un risque de dénutrition. Enfin, un score supérieur ou égal à 24 montre que la personne a un bon état alimentaire.",
	"item": [
		{
			"linkId": "50100",
			"text": "Dépistage",
			"type": "group",
			"item": [
				{
					"linkId": "50200",
					"text": "Le patient présente-t-il une perte d’appétit? A-t-il mangé moins ces 3 derniers mois par manque d’appétit, problèmes digestifs, difficultés de mastication ou de déglutition?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50201",
								"display": "Anorexie sévère"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50202",
								"display": "Anorexie modérée"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50203",
								"display": "Pas d’anorexie"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50300",
					"text": "Perte récente de poids (< 3 mois)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50301",
								"display": "Perte de poids > 3 kg"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50302",
								"display": "Ne sait pas"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50303",
								"display": "Perte de poids entre 1 et 3 kg"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "50304",
								"display": "Pas de perte de poids"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50400",
					"text": "Motricité",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50401",
								"display": "Du lit au fauteuil"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50402",
								"display": "Autonome à l’intérieur"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50403",
								"display": "Sort du domicile"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50500",
					"text": "Maladie aiguë ou stress psychologique lors des 3 derniers mois?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50501",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50502",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50600",
					"text": "Problèmes neuropsychologiques",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50601",
								"display": "Démence ou dépression sévère"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50602",
								"display": "Démence ou dépression modérée"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50603",
								"display": "Pas de problème psychologique"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "50700",
					"text": "Indice de masse corporelle (IMC)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50701",
								"display": "IMC < 19"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "50702",
								"display": "19 <= IMC < 21"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50703",
								"display": "21 <= IMC < 23"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						},
						{
							"valueCoding": {
								"code": "50704",
								"display": "IMC >= 23"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 3
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "mna-screening-instructions",
					"text": "12 points ou plus: normal, pas besoin de continuer l’évaluation. | 11 points ou moins: possibilité de malnutrition, continuez l’évaluation quand le formulaire apparait.",
					"type": "display",
					"_text": {
						"extension": [
							{
								"url": "http://hl7.org/fhir/StructureDefinition/rendering-xhtml",
								"valueString": "<strong>12 points ou plus</strong>: normal, pas besoin de continuer l’évaluation.<br/><strong>11 points ou moins</strong>: possibilité de malnutrition, continuez l’évaluation quand le formulaire apparait."
							}
						]
					}
				}
			]
		},
		{
			"linkId": "50800",
			"text": "Évaluation globale",
			"type": "group",
			"extension": [
				{
					"url": "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-enableWhenExpression",
					"valueExpression": {
						"language": "text/fhirpath",
						"expression": "%resource.item.where(linkId='50100').item.where(linkId='50200').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50300').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50400').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50500').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50600').answer.exists() and %resource.item.where(linkId='50100').item.where(linkId='50700').answer.exists() and (iif(%resource.item.where(linkId='50100').item.where(linkId='50200').answer.valueCoding.code='50202',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50200').answer.valueCoding.code='50203',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50302',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50303',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50300').answer.valueCoding.code='50304',3,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50400').answer.valueCoding.code='50402',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50400').answer.valueCoding.code='50403',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50500').answer.valueCoding.code='50502',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50600').answer.valueCoding.code='50602',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50600').answer.valueCoding.code='50603',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50702',1,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50703',2,0)+iif(%resource.item.where(linkId='50100').item.where(linkId='50700').answer.valueCoding.code='50704',3,0)) <= 11"
					}
				}
			],
			"item": [
				{
					"linkId": "50900",
					"text": "Le patient vit-il de façon indépendante à domicile?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "50902",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "50901",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51000",
					"text": "Prend plus de 3 médicaments prescrits par jour?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51001",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51002",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51100",
					"text": "Escarre ou plaies cutanées?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51101",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51102",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51200",
					"text": "Combien de véritables repas prend-il par jour?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51201",
								"display": "1 repas"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51202",
								"display": "2 repas"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "51203",
								"display": "3 repas"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51300",
					"text": "Consomme-t-il?",
					"type": "group",
					"item": [
						{
							"linkId": "51400",
							"text": "Une fois par jour au moins des produits laitiers?",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51401",
										"display": "Oui"
									}
								},
								{
									"valueCoding": {
										"code": "51402",
										"display": "Non"
									}
								}
							],
							"required": true
						},
						{
							"linkId": "51500",
							"text": "Une ou deux fois par semaine des œufs ou des légumes secs?",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51501",
										"display": "Oui"
									}
								},
								{
									"valueCoding": {
										"code": "51502",
										"display": "Non"
									}
								}
							],
							"required": true
						},
						{
							"linkId": "51600",
							"text": "Chaque jour de la viande, du poisson ou de la volaille?",
							"type": "choice",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
									"valueCodeableConcept": {
										"coding": [
											{
												"system": "http://hl7.org/fhir/questionnaire-item-control",
												"code": "radio-button",
												"display": "Radio Button"
											}
										]
									}
								}
							],
							"answerOption": [
								{
									"valueCoding": {
										"code": "51601",
										"display": "Oui"
									}
								},
								{
									"valueCoding": {
										"code": "51602",
										"display": "Non"
									}
								}
							],
							"required": true
						}
					]
				},
				{
					"linkId": "51700",
					"text": "Consomme-t-il deux fois par jour au moins des fruits ou des légumes?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51701",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51702",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "51800",
					"text": "Combien de boissons consomme-t-il par jour? (eau, jus, café, thé, lait...)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "51801",
								"display": "Moins de 3 verres"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "51802",
								"display": "De 3 à 5 verres"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "51803",
								"display": "Plus de 5 verres"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "51900",
					"text": "Manière de se nourrir",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "51901",
								"display": "Nécessite une assistance"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "51902",
								"display": "Se nourrit seul avec difficulté"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "51903",
								"display": "Se nourrit seul sans difficulté"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "52000",
					"text": "Le patient se considère-t-il bien nourri? (problèmes nutritionnels)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "52001",
								"display": "Malnutrition sévère"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "52002",
								"display": "Ne sait pas ou malnutrition modérée"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "52003",
								"display": "Pas de problème de nutrition"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							]
						}
					],
					"required": true
				},
				{
					"linkId": "52100",
					"text": "Le patient se sent-il en meilleure ou en moins bonne santé que la plupart des personnes de son âge?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "52101",
								"display": "Moins bonne"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "52102",
								"display": "Ne sait pas"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "52103",
								"display": "aussi bonne"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 2
								}
							],
							"valueCoding": {
								"code": "52104",
								"display": "Meilleure"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "52200",
					"text": "Circonférence brachiale (CB) en cm",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							],
							"valueCoding": {
								"code": "52201",
								"display": "CB < 21"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0.5
								}
							],
							"valueCoding": {
								"code": "52202",
								"display": "21 <= CB <= 22"
							}
						},
						{
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							],
							"valueCoding": {
								"code": "52203",
								"display": "CB > 22"
							}
						}
					],
					"required": true
				},
				{
					"linkId": "52300",
					"text": "Circonférence du mollet (CM) en cm",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						},
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
							"valueCode": "vertical"
						}
					],
					"answerOption": [
						{
							"valueCoding": {
								"code": "52301",
								"display": "CM < 31"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						},
						{
							"valueCoding": {
								"code": "52302",
								"display": "CM >= 31"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						}
					],
					"required": true
				}
			]
		}
	]
}
